"use client";
import Link from "next/link";
import { Breadcrumb } from "antd";
import "./index.scss";

const Navigation = ({ items = [] }) => {
  return (
    <div className="wp-nav">
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link href="/">Trang Chủ</Link>
        </Breadcrumb.Item>
        {items.map((item, index) => (
          <Breadcrumb.Item key={index}>
            <Link href={item.href}>{item.label}</Link>
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default Navigation;
